module.exports = __webpack_public_path__ + "img/categorie-accesoires-famille-boutrais.ae0c8d33.webp";